module.exports = __webpack_public_path__ + "img/logo_tefcu.6b1982f3.png";